export enum PersonRole {
    HotWorker = 1,
    FireWatcher = 2,
    PostFireWatcher = 3,
    PermitIssuer = 4,
    PendingIssuer = 5,
    Observer = 6,
    Superintendent = 7,
}
